import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertCircle, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HolidayBanner = () => {
  const [notices, setNotices] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem('impetus-dismissed-notices') || '[]');
    } catch {
      return [];
    }
  });

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await axios.get(`${API}/notices/active`);
        if (mounted) setNotices(res.data);
      } catch (e) {
        // silent fail - banner is optional
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  const handleDismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    try {
      sessionStorage.setItem('impetus-dismissed-notices', JSON.stringify(next));
    } catch {}
  };

  const visible = notices.filter((n) => !dismissed.includes(n.notice_id));
  if (visible.length === 0) return null;

  return (
    <div className="fixed top-20 left-0 right-0 z-40 px-4 space-y-2" data-testid="holiday-banner-wrapper">
      {visible.map((notice) => (
        <div
          key={notice.notice_id}
          className="max-w-7xl mx-auto bg-gradient-to-r from-[#A0451E] to-[#D97706] text-white rounded-xl shadow-lg overflow-hidden"
          data-testid={`holiday-banner-${notice.notice_id}`}
        >
          <div className="flex items-start gap-3 px-5 py-3">
            <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <div className="flex-grow">
              <p className="font-body font-semibold text-sm">{notice.title}</p>
              <p className="font-body text-sm text-white/90 leading-relaxed">{notice.message}</p>
            </div>
            <button
              onClick={() => handleDismiss(notice.notice_id)}
              className="text-white/80 hover:text-white p-1 flex-shrink-0"
              aria-label="Dismiss"
              data-testid={`holiday-banner-dismiss-${notice.notice_id}`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HolidayBanner;
